module.exports = __webpack_public_path__ + "static/img/wuhanshizhongxinyiy.e3710e68.png";